<template>
  <!-- 投票單 列印頁 -->
  <!-- 戶別只能 14 個字，社區名稱只能 7 個字，超過則「...」 -->
  <div
    id="printVotingPaperBig"
    ref="printPage"
  >
    <div
      v-for="votingPaper in votingPapers"
      :key="votingPaper.barcode"
      class="card"
    >
      <div class="nav">
        <div class="householdArea">
          <div class="address">
            <span class="key">戶別</span><span class="value">{{ votingPaper.tabletName }}</span>
          </div>
          <div class="tablet">
            <span class="key">{{ areaPerPerson }}</span><span class="value">{{ votingPaper.area }} {{ unit }}</span>
          </div>
        </div>
        <div class="communityArea">
          <img
            alt="voteIcon"
            class="voteIcon"
            src="@/assets/img/unitOwnerAssembly/attendanceCard/IanLaiVote.svg"
          >
          <div class="name">
            {{ communityName }}
          </div>
        </div>
      </div>
      <div
        v-if="1"
        class="content-container"
      >
        <div class="assemblyNameContainer">
          <div class="assemblyName">
            {{ assemblyTitle }}
          </div>
        </div>
        <div class="content">
          <div class="topicNameContainer">
            <div class="topicName">
              {{ votingPaper.title }}
            </div>
          </div>
          <div class="dash" />
          <div class="topicDescription">
            議案說明
          </div>
          <div class="topicDescriptionContentContainer">
            <div class="topicDescriptionContent">
              {{ votingPaper.description }}
            </div>
          </div>
          <div
            id="dash_bottom"
            class="dash"
          />
          <div class="checkbox-container">
            <div
              v-for="checkboxValue in checkboxValues"
              :key="checkboxValue"
              class="checkbox-wrapper"
            >
              <div class="checkbox-square" />
              <div class="checkbox-value">
                {{ checkboxValue }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="newsContainer" />
        <div class="barcodeAndSmartDailyContainer">
          <div class="barcode">
            <VueBarcode
              :value="votingPaper.barcode"
              :options="barcodeOptions"
              tag="img"
            />
          </div>
          <div class="smartDailyAndBulletImgContainer">
            <img
              class="smartDailyArea"
              alt="smartDailyArea"
              src="@/assets/img/unitOwnerAssembly/attendanceCard/smartDaily.svg"
            >
            <img
              class="bulletNewsImg"
              alt="bulletNewsImg"
              src="@/assets/img/unitOwnerAssembly/attendanceCard/bulletNewsImg.svg"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueBarcode from '@chenfengyuan/vue-barcode'
import { getBarcodeOptionsByDigit } from '../../utils/UnitOwnerAssemblyUtils'
import tw from '../../utils'
export default {
  components: {
    VueBarcode
  },
  data () {
    const { areaPerPerson, unit } = tw
    return {
      areaPerPerson,
      unit,
      barcodeOptions: null,
      communityName: JSON.parse(localStorage.getItem('loginUserInfo')).CommunityName,
      attendanceCardList: [],
      topicList: [],
      votingPapers: [],
      assemblyId: '',
      assemblyTitle: '',
      checkboxValues: ['同意', '反對', '廢票']
    }
  },
  methods: {
    // 列印，要後續取得
    async print (assemblyId, assemblyTitle, topicList) {
      this.fullScreenLoading(true)
      this.assemblyId = assemblyId
      this.assemblyTitle = assemblyTitle
      this.votingPapers = []
      let res = await this.getAttendanceCardList()
      // eslint-disable-next-line eqeqeq
      if (topicList == undefined) { res = await this.getTopic() } else { this.topicList = topicList }
      if (!res) {
        this.$message({
          message: '發生未知錯誤，請稍後再試',
          type: 'warning'
        })
        this.fullScreenLoading(false)
        return
      }

      this.printData()
    },
    // 處理列印資料
    printData () {
      console.log('投票單', this.attendanceCardList)
      if (this.topicList.length < 1) {
        this.fullScreenLoading(false)
        this.$message({
          message: '此會議暫無議案',
          type: 'warning'
        })
        return
      }
      this.barcodeOptions = getBarcodeOptionsByDigit(this.attendanceCardList[0].barcode.length, 'big')
      for (let i = 0; i < this.attendanceCardList.length; i++) {
        for (let j = 0; j < this.topicList.length; j++) {
          this.votingPapers.push({
            area: this.attendanceCardList[i].area,
            // area: (this.attendanceCardList[i].areaRatio * 100).toFixed(2).toString(),
            barcode: this.attendanceCardList[i].barcode,
            tabletName: this.attendanceCardList[i].tabletName,
            title: this.topicList[j].title,
            description: this.topicList[j].description
          })
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.$print(this.$refs.printPage, null, true)
          this.fullScreenLoading(false)
        }, 300)
      })
    },
    // 取得會議條碼
    getAttendanceCardList () {
      return new Promise((resolve, reject) => {
        apiUnitOwnerAssembly.Print.GetAttendanceCardList(
          {
            AssemblyId: this.assemblyId
          }
        ).then(res => {
          if (res.status === 200) {
            this.attendanceCardList = res.data
            resolve(true)
          }
        }).catch((err) => {
          console.log('錯誤訊息：', err.response)
          if (err.response && err.response.status >= 400) {
            resolve(false)
          }
        })
      })
    },
    // 取得議案資料
    getTopic () {
      return new Promise((resolve, reject) => {
        apiUnitOwnerAssembly.Topic.GetTopicList(
          {
            AssemblyId: this.assemblyId
          }
        ).then(res => {
          if (res.status === 200) {
            this.topicList = res.data
            console.log('topicList', this.topicList)
            resolve(true)
          }
        }).catch((err) => {
          console.log('錯誤訊息：', err.response)
          if (err.response && err.response.status >= 400) {
            resolve(false)
          }
        })
      })
    },
    // 全屏loading畫面
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料處理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (!display) { loadingWrap.close() }
    }
  }
}
</script>
<style lang="sass" scoped>
$card-padding-lr: 16
$nav-padding-lr: 20
$nav-padding-top: 14
$nav-padding-bottom: 10
$household-key-padding-right: 8
$vote-icon-width: 34
$vote-icon-height: 39
$assembly-name-container-padding-lr: 8
$assembly-name-container-padding-top: 10
$assembly-name-container-padding-bottom: 8
$assembly-name-container-height: 100
$content-container-padding-lr: 18
$content-container-padding-top: 12
$topic-name-container-height: 112
$topic-description-padding-bottom: 4
$dash-margin-tb: 8
$checkbox-container-gap: 20
$checkbox-wrapper-gap: 6
$checkbox-square-size: 28
$checkbox-tb: 14
$footer-padding-top: 11
$footer-padding-bottom: 10
$barcode-and-smartDaily-container-gap: 14
@function resize($size)
  @return $size * 0.9px
=flexTextOverflow
  min-width: 0
  text-overflow: ellipsis
  overflow: hidden
  white-space: nowrap
=multilineTextOverflow ($line)
  display: -webkit-box
  max-width: 100%
  -webkit-line-clamp: $line
  -webkit-box-orient: vertical
  overflow: hidden
// *
  // 若 margin 為 0 則列印邊界將不會有網頁名稱、日期、網址、頁碼
  // margin: 0;
// 撇除其他因素制定列印的方向可以這樣寫，但目前共用的列印 function 會抓取該頁所有 css，同個頁面又有多個列印區塊，直接設定方向將互相覆蓋影響，因此列印方向直接寫進共用的列印 function
// @media print
//   @page
//     size: A4 landscape !important
@media print, screen
  *
    -webkit-print-color-adjust: exact !important
    // 不知為何父層有一個 line-height: 1 的屬性
    line-height: normal !important
  #printVotingPaperBig
    // 橫的
    width: 297mm
    text-align: start
    .card
      width: 50%
      height: 210mm
      @media print
        // 列印邊界的預設值會塞網頁名稱、日期、網址、頁碼，造成可用高度縮減
        height: calc(210mm * 0.9625)
        display: inline-flex
        flex-direction: column
        align-items: center
        border: dashed 0.4px #e1e1e1
        box-sizing: border-box
      .nav
        display: flex
        width: 100%
        justify-content: space-between
        align-items: center
        padding: 0 resize($nav-padding-lr)
        padding-top: resize($nav-padding-top)
        padding-bottom: resize($nav-padding-bottom)
        box-sizing: border-box
        .householdArea
          flex-basis: 60%
          width: 60%
          .address, .tablet
            text-overflow: ellipsis
            overflow: hidden
            white-space: nowrap
            width: 100%
            box-sizing: border-box
            font-weight: 600
            text-align: start
            color: $mainFontColor
            display: flex
            span
              line-height: 24.5px !important
            .key
              font-weight: 600
              font-size: 16px
              color: $darkGrayFontColor
              padding-right: resize($household-key-padding-right)
            .value
              font-weight: 600
              font-size: 18px
              flex-grow: 1
              +flexTextOverflow
        .communityArea
          flex-basis: 40%
          width: 40%
          display: flex
          align-items: center
          gap: 8px
          display: flex
          justify-content: flex-end
          .voteIcon
            width: resize($vote-icon-width)
            height: resize($vote-icon-height)
          .name
            font-weight: 600
            font-size: 20px
            +flexTextOverflow
      .content-container
        flex-grow: 1
        width: 100%
        padding: 0 16px
        box-sizing: border-box
        display: flex
        flex-direction: column
        .assemblyNameContainer
          width: 100%
          box-sizing: border-box
          display: flex
          justify-content: center
          align-items: center
          height: resize($assembly-name-container-height)
          padding: resize($assembly-name-container-padding-top) resize($assembly-name-container-padding-lr) resize($assembly-name-container-padding-bottom)
          .assemblyName
            padding: 0 24px
            box-sizing: border-box
            align-items: center
            font-weight: 600
            font-size: 18px
            text-align: center
            color: $darkGrayFontColor
            +multilineTextOverflow(3)
        .content
          flex-grow: 1
          width: 100%
          border-radius: 20px
          border: solid 2px $bgDarkBg
          display: flex
          flex-direction: column
          align-items: center
          padding: 0 resize($content-container-padding-lr)
          padding-top: resize($content-container-padding-top)
          padding-bottom: resize($checkbox-tb)
          box-sizing: border-box
          .dash
            width: 100%
            border: 1px dashed $bgDarkBg
            margin: resize($dash-margin-tb) 0
          #dash_bottom
            margin-bottom: resize($checkbox-tb)
          .topicNameContainer
            display: flex
            justify-content: center
            align-items: center
            height: resize($topic-name-container-height)
            width: 100%
            text-align: center
            .topicName
              // width: 100%
              padding: 0 24px
              box-sizing: border-box
              align-items: center
              font-weight: 600
              font-size: 20px
              text-align: center
              color: $mainFontColor
              +multilineTextOverflow(4)
              text-align: center
          .topicDescription
            font-weight: 600
            font-size: 18px
            color: $mainFontColor
            padding-bottom: resize($topic-description-padding-bottom)
          .topicDescriptionContentContainer
            flex-grow: 1
            width: 100%
            .topicDescriptionContent
              font-size: 18px
              color: $mainFontColor
              +multilineTextOverflow(10)
          .checkbox-container
            width: 100%
            justify-content: end
            display: flex
            gap: resize($checkbox-container-gap)
            .checkbox-wrapper
              display: flex
              align-items: center
              gap: resize($checkbox-wrapper-gap)
              .checkbox-square
                width: resize($checkbox-square-size)
                height: resize($checkbox-square-size)
                border-radius: 8px
                border: solid 3px $borderDark4
                box-sizing: border-box
              .checkbox-value
                font-weight: 600
                font-size: 22px
                text-align: left
                color: $mainFontColor
      .footer
        gap: 16px
        width: 100%
        display: flex
        align-items: center
        padding: resize($footer-padding-top) 16px resize($footer-padding-bottom)
        box-sizing: border-box
        .newsContainer
          width: 216px
          height: 108px
          border: 1px solid black
          flex-shrink: 0
        .barcodeAndSmartDailyContainer
          display: flex
          flex-grow: 1
          flex-direction: column
          gap: resize($barcode-and-smartDaily-container-gap)
          .barcode
            width: 100%
            height: 50px
            display: flex
            justify-content: center
            align-items: center
            overflow: hidden
          .smartDailyAndBulletImgContainer
            display: flex
            justify-content: center
            align-items: center
            gap: 21px
            .smartDailyArea
              width: 110px
              height: 34.4px
            .bulletNewsImg
              width: 160px
              height: 44px
@media screen
  #printVotingPaperBig
    display: none
</style>
